/**
 * Action types for the bulk action title bar
 * These define the available actions that can be displayed
 */
export const ACTION_TYPES = {
  SEARCH: 'search',
  EDIT: 'edit',
  EDIT_PRICE: 'editPrice',
  EDIT_DESIGNER: 'editDesigner',
  BULK_EDIT_CONTRACT: 'bulkEditContract',
  BULK_EDIT_PRICE: 'bulkEditPrice',
  BULK_REFINE_STYLES: 'bulkRefineStyles',
  MAP_FONT: 'mapFont',
  MOVE_FONT: 'moveFont',
  ADD_TAGS: 'addTags',
  AUTO_SORT_STYLES: 'autoSortStyles',
  DELETE: 'delete',
  SPLIT_FAMILY: 'splitFamily',
  CUSTOM: 'custom'
}

/**
 * Icon component mapping for each action type
 */
export const ACTION_ICON_MAP = {
  [ACTION_TYPES.SEARCH]: 'MdIconSearch',
  [ACTION_TYPES.EDIT]: 'MdIconEdit',
  [ACTION_TYPES.EDIT_PRICE]: 'MdIconEdit',
  [ACTION_TYPES.EDIT_DESIGNER]: 'MdIconUser',
  [ACTION_TYPES.BULK_EDIT_CONTRACT]: 'MdIconApplications',
  [ACTION_TYPES.BULK_EDIT_PRICE]: 'MdIconMoney',
  [ACTION_TYPES.BULK_REFINE_STYLES]: 'MdIconFonts',
  [ACTION_TYPES.MAP_FONT]: 'MdIconMerge',
  [ACTION_TYPES.MOVE_FONT]: 'MdIconMoveFolder',
  [ACTION_TYPES.ADD_TAGS]: 'MdIconTag',
  [ACTION_TYPES.AUTO_SORT_STYLES]: 'MdIconSort',
  [ACTION_TYPES.DELETE]: 'MdIconEmptyTrash',
  [ACTION_TYPES.SPLIT_FAMILY]: 'MdIconSubset'
}

/**
 * Default event names for each action type
 */
export const ACTION_EVENT_MAP = {
  [ACTION_TYPES.SEARCH]: 'open-search-modal',
  [ACTION_TYPES.EDIT]: 'open-edit-modal',
  [ACTION_TYPES.EDIT_PRICE]: 'open-edit-price-modal',
  [ACTION_TYPES.EDIT_DESIGNER]: 'edit-designer-clicked',
  [ACTION_TYPES.BULK_EDIT_CONTRACT]: 'open-edit-modal',
  [ACTION_TYPES.BULK_EDIT_PRICE]: 'open-edit-price-modal',
  [ACTION_TYPES.BULK_REFINE_STYLES]: 'bulk-refine-styles-clicked',
  [ACTION_TYPES.MAP_FONT]: 'open-mapFont-modal',
  [ACTION_TYPES.MOVE_FONT]: 'open-moveFont-modal',
  [ACTION_TYPES.ADD_TAGS]: 'add-tags-clicked',
  [ACTION_TYPES.AUTO_SORT_STYLES]: 'auto-sort-clicked',
  [ACTION_TYPES.DELETE]: 'delete-clicked',
  [ACTION_TYPES.SPLIT_FAMILY]: 'open-split-family-modal'
}

/**
 * Action positions
 */
export const ACTION_POSITION = {
  LEFT: 'left',
  RIGHT: 'right',
  MORE_MENU: 'moreMenu'
}

